import { AbstractEntityTabLoader } from '../../utils/component/abstract-entity-tab-loader/abstract-entity-tab.loader';
import { TestEntity } from '../test.entity';

export class TestTabLoader
  extends AbstractEntityTabLoader<TestEntity> {
  protected pageSize = 20;
  protected sort = 'name';
  protected searchFilterKey = 'filter[nameLike]';
}
